import { Matrix} from "babylonjs";
import PoseBase from "./PoseBase";
import PoseFilter from "./PoseFilter";
import PoseSmooth from "./PoseSmooth";
import PoseConstraints from "./PoseConstraints";

export default class Pose extends PoseBase {

  private matricesToProcess:Matrix[] = [];
  private poseFilter?: PoseFilter;
  private poseSmooth?: PoseSmooth;
  private poseConstraints?: PoseConstraints;

  constructor() {
    super();
  }

  public enablePoseFilter() { 
    if( !this.poseFilter ) this.poseFilter = new PoseFilter(); 
  }

  public enablePoseSmooth() { 
    if( !this.poseSmooth ) this.poseSmooth = new PoseSmooth(); 
  }

  public setPositionConstraints({positionX, positionY, positionZ}: {positionX?:number; positionY?:number; positionZ?:number}): void {
    if (!this.poseConstraints) {
      this.poseConstraints = new PoseConstraints();
    }
    this.poseConstraints.constraintPositionX = positionX;
    this.poseConstraints.constraintPositionY = positionY;
    this.poseConstraints.constraintPositionZ = positionZ;
  }

  public setRotationConstraints({rotationX, rotationY, rotationZ}: {rotationX?:number; rotationY?:number; rotationZ?:number}): void {
    if (!this.poseConstraints) {
      this.poseConstraints = new PoseConstraints();
    }
    this.poseConstraints.constraintRotationX = rotationX;
    this.poseConstraints.constraintRotationY = rotationY;
    this.poseConstraints.constraintRotationZ = rotationZ;
  }

  public override setMatrix(matrix:Matrix) {
    this.matricesToProcess.push( matrix.clone() );
  }

  public update(timeDelta: number) {
    const matrix = this.getMatrix(); // current matrix.
    //
    if( this.matricesToProcess.length > 0 ) {
      if( this.poseFilter ) {
        for( let i=0; i<this.matricesToProcess.length; i++ ) {
          const matrixToProcess = this.matricesToProcess[i];
          this.poseFilter.setMatrix( matrixToProcess );
        }
        this.poseFilter.getMatrixToRef( matrix );
      } else {
        const lastMatrix = this.matricesToProcess[this.matricesToProcess.length-1];
        matrix.copyFrom( lastMatrix );
      }
      if( this.poseSmooth ) {
        this.poseSmooth.setMatrix( matrix );
      }
    }
    this.matricesToProcess.length = 0; // matrices processed, clear the array.
    //
    if( this.poseSmooth ) {
      this.poseSmooth.update( timeDelta );
      this.poseSmooth.getMatrixToRef( matrix );
    }
    if( this.poseConstraints ) {
      this.poseConstraints.setMatrix( matrix );
      this.poseConstraints.update();
      this.poseConstraints.getMatrixToRef( matrix );
    }
    //
    super.setMatrix( matrix );
  }

  public reset() {
    super.reset();
    this.poseFilter?.reset();
    this.poseSmooth?.reset();
    this.poseConstraints?.reset();
  }
}